<template>
  <div class="tip_container" v-if="isShow">
    <div class="tipTitle">
      <h4>提示</h4>
      <div class="el-icon-close icon" @click="isShow = false"></div>
    </div>
    <div class="tipContent">
      <div class="content">
        <div class="wenzi">{{tipText}}!</div>
      </div>
    </div>
    <!-- <div class="tipFooter">
      <div class="btn_box">
        <div class="btn" @click="isShow = false">确定</div>
      </div> 
    </div> -->
  </div>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  props:{
    tipShow:{
      type:Boolean,
      default(){
        false
      }
    }
  },
  data(){
    return{
      isShow:false,
      tipText:'',
    }
  },
  created() {
    this.isShow = this.tipShow
    // 获取兄弟组件传来的值
    Bus.$on("getTipVisible", (data) => {
      this.isShow = data.tipShow
      this.tipText = data.tipText
    })
  },
};
</script>

<style lang="less" scoped>
@import "/src/css/base.css";
// 弹窗
.tip_container {
  width: 430px;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  box-shadow: 0px 5px 21px 0px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  overflow: hidden;
}
.tip_container .tipTitle {
  padding: 0 30px;
  box-sizing: border-box;
  height: 42px;
  font-size: 18px;
  line-height: 42px;
  color: #fff;
  background: #bb0015 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tip_container .tipTitle .icon {
  font-size: 24px;
  cursor: pointer;
}
.tip_container .tipContent {
  padding: 15px 30px;
  box-sizing: border-box;
}
.tip_container .tipContent .content .wenzi {
  font-size: 18px;
  color: #666;
  line-height: 1.5;
  text-align: center;
  margin: 40px 0;
}
.tip_container .tipFooter .btn_box {
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.tip_container .tipFooter .btn_box .btn {
  width: 120px;
  margin: 0 20px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 38px;
  height: 38px;
  padding: 0;
  background-color: #bb0015;
  border: 1px solid #bb0015;
  overflow: hidden;
  border-radius: 2px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>